import {GraphObject, Node, Map as GoJSMap, InputEvent} from 'src/util/gojs/go';
import {ColorLegend} from 'src/types';
import {makeDiagram} from 'src/graph';
import {isLink, isNode} from 'src/util/gojs';
import {fetchDataForNode, commitNodesToDiagram} from 'src/graph';

import {makeLinkTemplate, makeNodeTemplate} from './templates';

export const makeDiagramInitializer = ({
  getColorTag,
  onContextClick,
  defaultLensValue,
}: {
  getColorTag: (_: undefined | string | { type?: string }) => ColorLegend[string],
  onContextClick?: (_: {x: number, y: number}) => void,
  defaultLensValue?: string
}) =>
  () => {
    const diagram = makeDiagram();

    if (defaultLensValue) {
      diagram.model.setDataProperty(diagram.model.modelData, 'lens', defaultLensValue);
    }

    diagram.nodeTemplateMap = new GoJSMap<string, Node>()
        .add('', makeNodeTemplate({
          handleContextClick: async (_e: InputEvent, obj: GraphObject) => {
            if (!isNode(obj)) {
              return;
            }
            const diagram = obj.diagram;
            if (!diagram) {
              return;
            }

            const point = diagram.lastInput.viewPoint;
            onContextClick && onContextClick({
              x: point.x,
              y: point.y,
            });
          },

          handleClickExpander: async (_e: InputEvent, obj: GraphObject) => {
            const node = obj.part;

            if (!isNode(node)) {
              return;
            }

            const diagram = node.diagram;
            if (!diagram) {
              return;
            }
            if (!node.isTreeExpanded) {
              const {nodes, edges} = await fetchDataForNode(node, getColorTag);
              diagram.commit(async (diagram) => {
                commitNodesToDiagram(diagram, {
                  nodes,
                  edges,
                });
                node.isTreeExpanded = true;
              });
            } else {
              node.collapseTree();
            }
          },
        }));

    diagram.linkTemplate = makeLinkTemplate({
      handleContextClick: async (_e: InputEvent, obj: GraphObject) => {
        if (!isLink(obj)) {
          return;
        }
        const diagram = obj.diagram;
        if (!diagram) {
          return;
        }

        const point = diagram.lastInput.viewPoint;
        onContextClick && onContextClick({
          x: point.x,
          y: point.y,
        });
      },
    });

    return diagram;
  };
